BaseRuleModel = require 'models/rule-base'
module.exports = Backbone.Model.extend _.clone(BaseRuleModel)
